import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class SelezionaPAModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack',
        '$uibModal',
        'configuration'
    ];

    private close: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private configuration: any
    ) {

        $scope.items = [];
        $scope.search = (errors) => {

            if ($.isEmptyObject(errors)) {
                $scope.searching = true;
                ArchiSmallServices.fatturaPaCessionary($scope.nome === undefined ? '' : $scope.nome, $scope.citta === undefined ? '' : $scope.citta, $scope.codicepa === undefined ? '' : $scope.codicepa)
                    .then((response: any) => {
                        $scope.items = response.resultList;
                        $scope.searching = false;
                        if ($scope.items.length === 0) {
                            $rootScope.alert('warning', 'Nessuna Pubblica Amministrazione trovata.');
                        }
                    }, (error) => {
                        $rootScope.alert('error', error);
                        $scope.searching = false;
                    });
            } else {
                $rootScope.setErrorFieldsTouched(errors);
                // $('[name='form2']').find('.ng-invalid:visible:first').focus();
            }
        };
        $scope.select = (item) => {
            this.close({ $value: item });
        };
    }
}

export const SelezionaPAModalComponent: ng.IComponentOptions = {
    template: require('./seleziona-pa-modal.html'),
    controller: SelezionaPAModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/seleziona-pa-modal/seleziona-pa-modal.ts